import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaginationCriteria, PaginatedResult } from 'jul-web-shared-lib';
import { ApiEndpoints } from '../../http/api-endpoints';
import { JulContextLibService } from 'jul-web-shared-lib/src/lib/components/context';
@Injectable({
    providedIn: 'root'
})
export class ImpersonalizationService {

    constructor(private http: HttpClient, private julContextService: JulContextLibService) { }

    getImpersonalizationList(criteria: PaginationCriteria<any>): Observable<PaginatedResult<any>> {
      this.julContextService.setContextNational();
        let paginatedResult: PaginatedResult<any> = new PaginatedResult<any>();
        return this.http.post(ApiEndpoints.core.impersonalization.getImpersonalizationList(), criteria, { observe: 'response' }).pipe(
            map((response: any) => {
                paginatedResult = response.body.data;
                return paginatedResult;
            }
        ));
    }

    getUsersList(businessEntityId: string, criteria: any): Observable<PaginatedResult<any>> {
      this.julContextService.setContextNational();
        let paginatedResult: PaginatedResult<any> = new PaginatedResult<any>();
        return this.http.post(ApiEndpoints.core.impersonalization.getUsersList(businessEntityId), criteria, { observe: 'response'}).pipe(
            map((response: any) => {
                paginatedResult = response.body.data;
                return paginatedResult;
            }
        ));
    }

    getImpersonalization(username: string, businessEntityId: string): Observable<any> {
      this.julContextService.setContextNational();
        return this.http.get<any>(ApiEndpoints.core.impersonalization.get(username, businessEntityId)).pipe(
            map((response: any) => <any>response.data)
        );
    }

}
